<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "App",
}
</script>

<style>
@import url('@/styles/index.css');

html {
    box-sizing: border-box;
}

*,
*::before,
*::after {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
}

li{
    list-style-type: none;
}

a{
    --color-link: #2253ff;
    color: var(--color-link);

    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    
    -webkit-user-drag: none;

    text-decoration: none;
}
</style>